<template>
  <div class="container my-5">
    <h1 class="display-6 text-center">What Our Students & their Parents Say</h1>

   <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
      <div class="col" v-for="(testimonial, index) in testimonials" :key="index">
        <div class="card h-100 shadow-sm">
          <div class="card-body testimonial-card p-4  rounded shadow-sm transition-card">
            <h6 class="card-title fs-6">{{ testimonial.title }}</h6>
            <p class="card-text" v-for="(line, i) in testimonial.comments" :key="i">
              {{ line }}
            </p>
          </div>
         <div class="card-footer text-muted small d-flex justify-content-between align-items-center">
  <span style="color: gold; font-size: 1.2rem;">★★★★★</span>
  <span>{{ testimonial.date }} by {{ testimonial.author }}</span>
</div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestimonialsView',
  data() {
    return {
      testimonials: [
        {
          title: 'iGCSE Cambridge Computer Science (Pseudocode)',
          comments: [
            'We just wanted to say a big thank you for all his help over the past few months for my son in his CS IGCSEs. He said that both his exams had gone really well! His lessons really made a difference with his coding skills really improving which gave him the confidence he needed for the CS GCSEs. We are so grateful for the support and the effort he put into helping him improve. Thank you again and wishing you best of luck in the future!',
          
          ],
          date: '17/05/2025',
          author: 'Parent of pupil'
        },
        {
          title: 'A-level Computer Science (AQA)',
          comments: [
            'Classes were very helpful throughout the year with flexible timings and helpful feedback for each lesson. Covered each part of the specification very well with lots of help during the NEA creation and development with useful changes and advice for each stage of the development process. He was extremely helpful with the skeleton code helping me to break down and annotate each line, which helped me to understand the code very well and led to me being confident in the exam.',
         
          ],
          date: '16/06/2025',
          author: 'Student'
        },
          {
          title: 'A-level Cambridge Computer Science (Programming/Paper 2,3 and 4)',
          comments: [
            'It has been a great help for the past couple months. Taught me a lot of information in a really short amount of time, just in time for my A level.',
         
          ],
          date: '26/05/2025',
          author: 'Student'
        },

        {
          title: 'iGCSE Cambridge Computer Science (Programming)',
          comments: [
            'I am in the process of learning how to approach the GCSE CAIE paper 2 15-marker almost from scratch.'+
            'I thought it would be quite a big challenge as I have never had any success with it but I am understanding code now better than I ever have. The tutor coding explanation is easy to understand, he is patient and goes through each line of code to ensure I know what is going on. He is better than any computer science teacher I have had at school.'+
            'Coding is becoming less of an impossible task and more exciting.',
            
         
          ],
          date: '20/04/2025',
          author: 'Student'
        },
        {
          title: 'A-level AQA Computer Science (both Papers)',
          comments: [
            'The teacher is excellent. Our son was getting an E grade and failing in his A level, he was completely deflated and wanted to give up the course. As a last bit of hope we contacted the tutor to see if a tutor could get him up a grade. Wow what can a say. His TAG Assessment Exam has gone from an ‘E’ to a ‘C’ in only month’s. He is more confident, happier and more comfortable in the subject. 3 more months to go to the real exam but he has made huge leaps forward. This is all down to the tutor. Big thanks',
         
            
         
          ],
          date: '26/02/2024',
          author: 'Parent of the Pupil'
        },

          {
          title: 'GCSE OCR Computer Science (both Papers)',
          comments: [
            'Absolutely brilliant. My son had given up hope with his computer science lessons at school and the tutor managed to install his confidence back after only 1 lesson. We are now not dreading the GCSE exam but actually looking forward to a good grade. Highly recommend him.',
         
            
         
          ],
          date: '13/02/2024',
          author: 'Parent of the Pupil'
        },



       //the following bracket is the end of comment list
      ]
    }
  }
}
</script>

<style scoped>
.transition-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  /*  //border-left: 5px solid #198754;Bootstrap green */
}

.transition-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  background-color: lightgrey; /* #f9fdfb;  light green tint on hover */
  color: black; /* #f9fdfb;  light green tint on hover */
  cursor: default;
}
</style>


